import { CouponService } from '../../_services/referral/coupon.service';
import { MenuService } from '../../_services/menu.service';
import { Component, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StoreService } from 'app/_services/store.service';
@Component({
  selector: 'app-block-participant-dialog',
  templateUrl: './block-participant-dialog.component.html',
  styleUrls: ['./block-participant-dialog.component.scss']
})
export class BlockParticipantDialogComponent implements OnDestroy {
  constructor(
    public bsModalRef: BsModalRef,
    public modalService: BsModalService,
    public store: StoreService,
    private menuService: MenuService,
    private couponService: CouponService
  ) {
    this.menuService.emit(true);
  }

  public referralStatus;
  public referralValue;
  public reason;
  public id;
  public status;
  public loading = false;
  public subscriptions = [];

  ngOnDestroy() {
    this.subscriptions.forEach((item, index, array) => {
      item.unsubscribe();
      array.splice(index, 1);
    });
  }

  blockParticipant() {
    this.loading = true;
    this.subscriptions.push(
      this.couponService.changeBlockStatus(this.id, this.status).subscribe((data) => {
        this.status = data.blocked;
        this.loading = false;
        this.bsModalRef.hide();
      })
    );
  }
}
